var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUserMap)?_c('div',{staticClass:"col-md-9 text-normal details-text",domProps:{"innerHTML":_vm._s(_vm.currentUserMap.content ? _vm.currentUserMap.content.rendered : '')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }